import React from 'react';

import { MjmlSection, MjmlColumn, MjmlDivider } from '../MjmlComponentsV2';

/**
 * @deprecated This component has been moved to @emails library (libs/emails/src/lib/components/EmailHorizontalRule.tsx).
 * Please import from 'emails' package instead.
 */
export function EmailHorizontalRule() {
  return (
    <MjmlSection background-color="#FFFFFF" padding="0">
      <MjmlColumn background-color="#FFFFFF">
        <MjmlDivider border-color="#EAECEF" border-width="1px" />
      </MjmlColumn>
    </MjmlSection>
  );
}
